import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EmployeeModel } from '../../../../../../shared/store/employee/types';
import { EmployeeService } from '../../../../../../shared/store/employee/employee.service';

@Component({
    selector: 'app-employee-details-public-informations',
    templateUrl: './employee-details-public-informations.component.html',
    styleUrls: ['./employee-details-public-informations.component.scss'],
    standalone: false
})
export class EmployeeDetailsPublicInformationsComponent {
  employeeDetail$: Observable<EmployeeModel>;

  constructor(private readonly employeeService: EmployeeService) {
    this.employeeDetail$ = this.employeeService.getById.value$;
  }
}
